import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from 'react-query';
import { ResourceLimitationPeriodsListQuery } from './ResourceLimitationPeriods.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import { PageRequest } from '@/core/request/PageRequest';
import {
  createResourceLimitationPeriod,
  deleteResourceLimitationPeriod,
  getResourceLimitationPeriod,
  listResourceLimitationPeriods,
} from './ResourceLimitationPeriods.service';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export function useResourceLimitationPeriodsList(
  params?: ResourceLimitationPeriodsListQuery,
  enabled = true,
) {
  return useInfiniteQuery(
    ['resource-limitation-periods', { ...params }],
    ({ pageParam }) => {
      const req: PageRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listResourceLimitationPeriods(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
      enabled:
        enabled &&
        hasPermissions([Authorities.RESOURCE_LIMITATION_PERIODS_VIEW]),
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useResourceLimitationPeriodsDetails(
  id?: number,
  enabled = false,
) {
  return useQuery(
    ['resource-limitation-periods/detail', id],
    () => (id ? getResourceLimitationPeriod(id) : undefined),
    {
      enabled: !!id && enabled,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useCreateResourceLimtationPeriod() {
  const queryClient = useQueryClient();

  return useMutation(createResourceLimitationPeriod, {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Período de limitação de recurso cadastrado com sucesso!',
      });

      queryClient.invalidateQueries(['resource-limitation-periods']);
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useDeleteResourceLimtationPeriod() {
  const queryClient = useQueryClient();

  return useMutation((id: number) => deleteResourceLimitationPeriod(id), {
    onSuccess() {
      notification.success({
        message: 'Sucesso',
        description: 'Período de limitação de recurso deletado com sucesso',
      });

      queryClient.invalidateQueries(['resource-limitation-periods']);
    },

    onError(error) {
      notificationError(error);
    },
  });
}
